import { Injectable } from '@angular/core';
import {
  CategoriesList,
  CreateResourcesResponse,
  DeleteResourcesResponse,
  ResourceDetailsResponse,
  ResourcesResponse,
  ResourceStatusResponse,
  RoleListResponse,
  SessionListResponse,
  SubCategoriesList
} from '../model/resource-details.model';
import { BehaviorSubject, Observable } from 'rxjs'
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { v1URL } from '../../../shared/constants/urls.constants';
import { CreateResourceStatus } from '../constants/create-resource-status.enum';

@Injectable({
  providedIn: 'root'
})
export class ResourcesHubService {

  layoutDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  isSavedAsDraft: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  lastUpdatedId: BehaviorSubject<string> = new BehaviorSubject(null)

  constructor(private commonService: CommonService) {
  }

  sendDataToParent(data: any) {
    this.layoutDataSubject.next(data)
  }

  setSaveAsDraft(isSavedAsDraft: boolean) {
    this.isSavedAsDraft.next(isSavedAsDraft);
  }


  getResourceDetails(payload: ResourceDetailsResponse['request']): Observable<ResourceDetailsResponse['response']> {
    const urlConfig = v1URL.resourceHub.resourceDetails(payload.id, payload.slug)
    return this.commonService.callAPI(urlConfig.method, urlConfig.url)
  }

  fetchSessionList(): Observable<SessionListResponse['response']> {
    const urlConfig = v1URL.filters.sessionList
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchRoleList(): Observable<RoleListResponse['response']> {
    const urlConfig = v1URL.filters.roles
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchCategoriesList(): Observable<CategoriesList['response']> {
    const urlConfig = v1URL.resourceHub.categories;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchSubCategoriesList(payload: SubCategoriesList['request']): Observable<SubCategoriesList['response']> {
    const urlConfig = v1URL.resourceHub.subCategories(payload.categories.join(CreateResourceStatus.subCategoriesQueryKey));
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchRelatedResources(payload: ResourcesResponse['request']): Observable<ResourcesResponse['response']> {
    const urlConfig = v1URL.resourceHub.relatedResources;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  createResource(payload: CreateResourcesResponse['request']): Observable<CreateResourcesResponse['response']> {
    const requestType = payload.id ? 'edit' : 'add'
    if (requestType === 'add') {
      return this.addNewResource(payload)
    } else {
      return this.editResource(payload)
    }
  }

  addNewResource(payload: CreateResourcesResponse['request']): Observable<CreateResourcesResponse['response']> {
    const urlConfig = v1URL.resourceHub.add;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  editResource(payload: CreateResourcesResponse['request']): Observable<CreateResourcesResponse['response']> {
    const updatedPayload = { ...payload }
    const urlConfig = v1URL.resourceHub.edit(payload.id);
    delete updatedPayload.id
    return this.commonService.callAPI(urlConfig.method, urlConfig.url, updatedPayload);
  }

  deleteResource(payload: DeleteResourcesResponse['request']): Observable<any> {
    const updatedPayload = { ...payload }
    const urlConfig = v1URL.resourceHub.edit(payload.id);
    delete updatedPayload.id
    return this.commonService.callAPI(urlConfig.method, urlConfig.url, updatedPayload);
  }

  fetchResourceList(payload: ResourcesResponse['request']): Observable<ResourcesResponse['response']> {
    const urlConfig = v1URL.resourceHub.list;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  fetchOrganisationsList(): Observable<any> {
    const urlConfig = v1URL.filters.clients;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url({}));
  }

  fetchGroupsList(params?: any): Observable<any> {
    const urlConfig = v1URL.filters.groups;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(params || {}));
  }

  fetchResourceStatusList(): Observable<ResourceStatusResponse['response']> {
    const urlConfig = v1URL.resourceHub.status;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  setLastUpdatedId(id: string) {
    this.lastUpdatedId.next(id)
  }
}
